import axios from 'axios';
import ValidateTokenExistence from '../../middlewares/ValidateTokenExistence';
const API_URL = `${process.env.REACT_APP_SERVER_USERS}`;

export const axiosClient = axios.create({
    baseURL: API_URL,
});

axiosClient.interceptors.request.use(async (config) => {
    try {
        if (config.url !== '/auth/sign-in') {
            const token = localStorage.getItem("token");
            await ValidateTokenExistence(config, token)
            return config;
        }
      } catch (error) {
        /*
          No se traga el error: devolver undefined dejaba salir la peticion
          sin cabecera de autorizacion, el backend respondia 400 "Error no hay
          token" y ese mensaje se lee como sesion rechazada, asi que no poder
          adjuntar el token terminaba cerrando la sesion.
        */
        return Promise.reject(error);
      }
});